module.exports = __webpack_public_path__ + "img/shadowkite-black-small.09254ce7.png";